import { Button } from "@mui/material";
import Styled from "styled-components";
import { respondTo } from "../../../respondTo";

export const DivContainer = Styled.div<{selecteditem?:number}>`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    max-width: 1512px;
    margin: 0 auto;

    ${respondTo.tablet_landscape_s`
        flex-direction: row;
        padding:2.5rem;
         
    `}
 
    ${respondTo.desktop`
    padding:2.5rem;
    `}


    ${respondTo.desktop_xl`
    padding: 2.5rem 4.375rem;
    `}
`;



export const VideoContainer = Styled.div`

${respondTo.tablet_landscape_s`
    order: 1;
    width: 53.7%;
`}

 ${respondTo.desktop`
    width: 45.80%;
   
  `}

  ${respondTo.desktop_xl`
    width: 58.33%;
    `}
`;


export const TextInnerContainer = Styled.div`
    padding: 0 1.25rem 2.5rem 1.25rem;
    
    ${respondTo.tablet_landscape_s`
    order: 0;
    width: 46.3%; 
    padding: 0 1.25rem 0 0;
 
    `}


 ${respondTo.desktop`
    order: 0;
    margin-top: auto;
    margin-bottom: auto;
    margin-left: auto;
    padding: 0 1.25rem 0 0;
    width: 54.20%;
   
  `}
    ${respondTo.desktop_xl`
        width: 41.67%;
        padding: 0 1.25rem 0 0;
    `}
`;

export const DivText = Styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 2.5rem 0 1.25rem;
   

    ${respondTo.desktop`
    padding: 0;
    `}

`;

export const BtnsContainer = Styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 1.25rem;

    ${respondTo.tablet_landscape_s`
       flex-direction: row;
       justify-content: flex-start;
       align-items: center;
       gap: 1.25rem;
    `}
    
       ${respondTo.desktop`
        margin-top: 2.5rem;
        padding: 0; 
    `}  
`;


export const StyledButton = Styled(Button)`
    transition: color 0.3s ease-in-out;
    transition: background-color 0.3s ease-in-out;
    text-transform: none;
    border-radius: 100px;
    gap: 8px;
    width: unset;
      @media screen and (max-width: 768px) {
         width: 20rem;
      }
  
`;

export const LinkBtn = Styled(Button)`
transition: color 0.3s ease-in-out;
text-transform: none;
border-radius: 100px;

@media screen and (max-width: 768px) {
         width: 20rem;
      }

${respondTo.tablet_landscape_s`
    margin-top: 0;
    `} 
`;




